const SRS_TO_GTS_PARAMS_MAPPING_SCHEMA = {
    adultsCount: 'coreFilters.adults',
    arrival: 'dates.arrivalDate',
    ascending: null,
    childrenCount: 'coreFilters.children',
    currency: 'currency', // TODO: missing in GTS parsedParams - add to GTS.
    departure: 'dates.departureDate',
    filter: 'filters',
    include: null,
    locale: null,
    maxBathrooms: 'coreFilters.maxBathrooms',
    maxBedrooms: 'coreFilters.maxBedrooms',
    maxPrice: 'coreFilters.maxPrice',
    minBathrooms: 'coreFilters.minBathrooms',
    minBedrooms: 'coreFilters.minBedrooms',
    minPrice: 'coreFilters.minPrice',
    mockApi: null,
    neLat: 'boundingBox.maxLat',
    neLong: 'boundingBox.maxLng',
    /*
        Nullified due making VRBO_SERP_HIDE_NON_DEFAULT_SEARCH test core.
        More details: https://tnl.prod.expedia.com/#experiment-detail/34559
    */
    orderBy: null,
    page: 'paging.page',
    pageSize: 'paging.pageSize',
    petIncluded: ['coreFilters.pets', (value) => (value ? 1 : 0)],
    q: 'q',
    regionId: ['region', (value) => `${value}`],
    site: null,
    swLat: 'boundingBox.minLat',
    swLong: 'boundingBox.minLng',
    zoom: null,
    searchTermUuid: 'lbsUuid',
    searchbucket: null,
    pinnedPropertyListing: ['pinnedPropertyListing', (value) => `${value}`],
    isSameDaySelected: 'dates.isSameDaySelected'
};
const DEFAULT_PARAMS = {
    paging: {page: 1, pageSize: 50}
};
const transformObjBySchema = (source, schema) => {
    return Object.keys(source).reduce((target, key) => {
        const fieldOptions = schema[key];

        if (fieldOptions) {
            const [path, transformValue] = [].concat(fieldOptions);
            const sourceValue = source[key];
            const targetValue = transformValue
                ? transformValue(sourceValue, source, key)
                : sourceValue;
            const pathParts = path.split('.');

            return {
                ...target,
                ...pathParts.reduceRight((result, part, index, array) => {
                    if (index === array.length - 1) {
                        return {
                            [part]: targetValue
                        };
                    }
                    return {
                        [part]: {
                            ...target[part],
                            ...result
                        }
                    };
                }, {})
            };
        }

        return target;
    }, DEFAULT_PARAMS);
};

module.exports = (srsParams) =>
    transformObjBySchema(srsParams, SRS_TO_GTS_PARAMS_MAPPING_SCHEMA);
